import React, { useEffect, useRef, useState, useContext } from 'react'
import './Ratetablesangh.css'
import { ToastContainer, toast } from 'react-toastify';
import back from "../../imgs/backexam.png";
import copy from "../../imgs/copy.png";
import { Face6TwoTone, FaxTwoTone } from '@mui/icons-material';
import axios from 'axios';
import Globalcontext from '../../Context/Globalcontext';
import { useTranslation } from "react-i18next";

const Ratetablesangh = (props) => {
    const [newedit, setNewedit] = useState("new");
    const [wait, setWait] = useState(false);
    const [waitself, setWaitself] = useState(false);
    const [neweditratib, setNeweditratib] = useState("new");
    const [input, setInput] = useState({
        type: "", fat: "", snf: "", vibhag: "",
        vibh1: "", vibh2: "", vibh3: "", vibh4: "", vibh5: "", vibh6: "", vibh7: "", vibh8: "",
        vibh1gay: "", vibh2gay: "", vibh3gay: "", vibh4gay: "", vibh5gay: "", vibh6gay: "", vibh7gay: "", vibh8gay: "",
        centerto: "", iname: "", centertoitr: "", pass: ""
    });
    const [ratibrate, setRatibrate] = useState({ mhrate: "", gayrate: "" });
    const [startFat, setStartFat] = useState(0);
    const [endFat, setEndFat] = useState(0);
    const [mainvalue, setmainvalue] = useState(0);
    const [startSNF, setStartSNF] = useState(0);
    const [endSNF, setEndSNF] = useState(0);
    const [cellValues, setCellValues] = useState({});
    const [fatDifferences, setFatDifferences] = useState([]);
    const [snfDifferences, setSNFDifferences] = useState([]);
    const [rowindexmain, setrowindexmain] = useState(0);
    const [colindexmain, setcolindexmain] = useState(0);
    const refshowold = useRef(null);
    const refoldclose = useRef(null);
    const refnextrate = useRef(null);
    const [DataSource, setDataSource] = useState([]);
    const refnextrateclose = useRef(null);
    const refcopy = useRef(null);
    const refcopyclose = useRef(null);
    const [triggerEffect, setTriggerEffect] = useState(0);
    const { submenu, setsubmenu, setHeadname } = useContext(Globalcontext);
    const inputRefs = useRef([]);

    const [t] = useTranslation();

    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);

    const handleshowold = (contact) => {
        checkexist();
    }

    const copyratetableself = async (event) => {
        setWaitself(true);
        var mainuser2 = jsEncode.encode("mamapr", 125);
        event.preventDefault();

        let rawData = {
            mainuser: localStorage.getItem("contact"),
            copymobno: input.centerto,
            type: input.type,
            mainuser2: mainuser2,
            flag: newedit
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://excellentdairy.com/dairy/php/cust/copyratetablesangh.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (response.data === "Records copied successfully.") { // ✅ keep excellentdairy response
                notify(t("ratetablesangh.toast.copied", { type: input.type, center: input.centerto }))
                handlecopyclose();
            } else {
                notifyerror(t("ratetablesangh.toast.try_again"));
            }
            setWaitself(false);
        }).catch(err => {
            console.log(err);
            setWaitself(false);
        });
    }

    const copyratetabledairy = async (event) => {
        setWait(true);
        var mainuser2 = jsEncode.encode("mamapr", 125);
        event.preventDefault();

        let rawData = {
            mainuser: localStorage.getItem("contact"),
            copymobno: input.iname,
            type: input.type,
            mainuser2: mainuser2,
            flag: newedit
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://excellentdairy.com/dairy/php/cust/copyratetablesangh.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (response.data === "Records copied successfully.") { // ✅ keep excellentdairy response
                notify(t("ratetablesangh.toast.copied", { type: input.type, center: input.centerto }))
                handlecopyclose();
            } else {
                notifyerror(t("ratetablesangh.toast.try_again"));
            }
            setWait(false);
        }).catch(err => {
            console.log(err);
            setWait(false);
        });
    }

    useEffect(() => {
        if (input.iname.length >= 10) {
            if (input.pass == localStorage.getItem("adminpass")) {
                getotherkendra();
            }
            else {
                notifyerror(t("ratetablesangh.toast.wrong_password"));
                setInput(value => ({ ...value, iname: '' }))
            }
        }
    }, [input.iname]);

    async function getotherkendra() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => props.setProgress(50), 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getitrkendra.php', { mobno: input.iname, mainuser2: mainuser2 }).then(function sample(response) {
            setInput(value => ({
                ...value,
                centertoitr: response.data[0].name + " (" + input.iname + ")",
                centerto: input.iname
            }))
        }).catch(err => {
            console.log(err);
        });
    }

    async function getkendralist() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => props.setProgress(50), 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getkendra2.php', { mainuser: localStorage.getItem("contactplant"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                setDataSource(response.data);
                setTimeout(() => props.setProgress(100), 200);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (inputRefs.current[0]) inputRefs.current[0].focus();
        getratibrate();
    }, [])

    async function checkexist() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => props.setProgress(50), 200);

        try {
            const response = await axios.post(
                'https://excellentdairy.com/dairy/php/cust/krateexistvibhag.php',
                {
                    vibhag: input.vibhag !== 'Ratechart-9 (M)' ? 'Ratechart-1' : 'Ratechart-9 (M)',
                    type: input.type,
                    mainuser: localStorage.getItem("contact"),
                    mainuser2: mainuser2
                }
            );
            if (response.data.length > 0) {
                refshowold.current.click();
            } else {
                setStartFat(0); setEndFat(0); setmainvalue(0); setStartSNF(0); setEndSNF(0);
                setCellValues({}); setFatDifferences([]); setSNFDifferences([]);
                setrowindexmain(0); setcolindexmain(0);
                createTable();
            }
        } catch (error) {
            console.log(error);
            refoldclose.current.click();
        }
    }

    const handleoldclose = () => refoldclose.current.click();

    const handlenextrate = () => {
        refnextrate.current.click();
        getoldnextrates();
    }

    const handlenextrateclose = () => refnextrateclose.current.click();
    const handlecopy = () => refcopy.current.click();
    const handlecopyclose = () => refcopyclose.current.click();

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }))
    }

    const opendurusti = () => {
        setsubmenu("nrepair");
        setHeadname(t("ratetablesangh.head.new_rate_repair"));
    };

    useEffect(() => {
        if (input.type === "Buffalo" || input.type === "Cow") {
            if (input.vibhag !== "विभाग निवडा") {
                handleshowold();
            }
        }
    }, [input.type])

    useEffect(() => {
        if (input.vibhag === "Ratechart-1") {
            if (input.vibhag !== "विभाग निवडा") {
                getoldnextrates();
                handleshowold();
            }
        } else {
            getoldnextrates();
        }
    }, [input.vibhag])

    async function getratetable() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => props.setProgress(50), 200);

        let typeid = (input.type === "Buffalo") ? "1" : "2"; // ✅ keep excellentdairy mapping

        try {
            const response = await axios.post(
                'https://excellentdairy.com/dairy/php/cust/getkratesangh.php',
                {
                    typeid: typeid,
                    vibhag: input.vibhag === 'Ratechart-9 (M)' ? 'Ratechart-9 (M)' : 'Ratechart-1',
                    type: input.type,
                    mainuser: localStorage.getItem("contact"),
                    mainuser2: mainuser2
                }
            );

            if (response.data.length > 0) {
                setNewedit("edit");
                if (input.type === "Buffalo") localStorage.setItem("mhrates", JSON.stringify(response.data));
                else if (input.type === "Cow") localStorage.setItem("gayrates", JSON.stringify(response.data));

                const groupedData = response.data.reduce((acc, item) => {
                    const fat = parseFloat(item.fat);
                    const snf = parseFloat(item.snf);
                    if (!acc[fat]) acc[fat] = [];
                    acc[fat].push(snf);
                    return acc;
                }, {});

                const fatValues = Object.keys(groupedData).map(parseFloat);
                setStartFat(Math.min(...fatValues));
                setEndFat(Math.max(...fatValues));

                const snfValues = response.data.map(item => parseFloat(item.snf));
                setStartSNF(Math.min(...snfValues));
                setEndSNF(Math.max(...snfValues));

                let responseData = response.data;
                let formattedData = [];
                let currentFat = null;

                responseData.forEach((item) => {
                    const { fat, snf, rate } = item;
                    let adjustedRate = parseFloat(rate);

                    if (input.vibhag === 'Ratechart-2') adjustedRate += (input.type === 'Buffalo') ? parseFloat(input.vibh2) : parseFloat(input.vibh2gay);
                    else if (input.vibhag === 'Ratechart-3') adjustedRate += (input.type === 'Buffalo') ? parseFloat(input.vibh3) : parseFloat(input.vibh3gay);
                    else if (input.vibhag === 'Ratechart-4') adjustedRate += (input.type === 'Buffalo') ? parseFloat(input.vibh4) : parseFloat(input.vibh4gay);
                    else if (input.vibhag === 'Ratechart-5') adjustedRate += (input.type === 'Buffalo') ? parseFloat(input.vibh5) : parseFloat(input.vibh5gay);
                    else if (input.vibhag === 'Ratechart-6') adjustedRate += (input.type === 'Buffalo') ? parseFloat(input.vibh6) : parseFloat(input.vibh6gay);
                    else if (input.vibhag === 'Ratechart-7') adjustedRate += (input.type === 'Buffalo') ? parseFloat(input.vibh7) : parseFloat(input.vibh7gay);
                    else if (input.vibhag === 'Ratechart-8') adjustedRate += (input.type === 'Buffalo') ? parseFloat(input.vibh8) : parseFloat(input.vibh8gay);

                    if (fat !== currentFat) {
                        currentFat = fat;
                        formattedData.push([{ fat, snf, rate: adjustedRate.toFixed(2) }]);
                    } else {
                        formattedData[formattedData.length - 1].push({ fat, snf, rate: adjustedRate.toFixed(2) });
                    }
                });

                generateTable(formattedData);
            } else {
                generateTable([]);
                refoldclose.current.click();
            }

        } catch (error) {
            console.log(error);
            refoldclose.current.click();
        }
    }

    function generateTable(data) {
        const table = document.getElementById('myTable');
        if (!table) return;

        data.sort((a, b) => parseFloat(a[0].fat) - parseFloat(b[0].fat));
        table.innerHTML = '';

        const headerRow = table.insertRow();
        const labelCell = headerRow.insertCell();
        const labelSpan = document.createElement('span');
        labelSpan.textContent = t("ratetablesangh.table.fat_snf");
        labelCell.appendChild(labelSpan);
        labelCell.classList.add('non-editable');

        for (let i = 0; i < data[0].length; i++) {
            const snfCell = headerRow.insertCell();
            snfCell.textContent = data[0][i].snf;
            snfCell.classList.add('non-editable');
        }

        for (let i = 0; i < data.length; i++) {
            const row = table.insertRow();
            const fatCell = row.insertCell();
            fatCell.textContent = data[i][0].fat;
            fatCell.classList.add('non-editable');

            for (let j = 0; j < data[i].length; j++) {
                const cell = row.insertCell();
                cell.textContent = data[i][j].rate;
                cell.addEventListener('click', handleCellClick);
            }
        }
        handleoldclose();
    }

    const handleCellClick = (rowIndex, colIndex, currentValue) => {
        setrowindexmain(rowIndex);
        setcolindexmain(colIndex);

        const table = document.getElementById('myTable');
        const cells = table.getElementsByTagName('td');
        for (let i = 0; i < cells.length; i++) cells[i].addEventListener('click', handleCellClick2);

        function handleCellClick2(event) {
            const cell = event.target;
            if (cell.getAttribute('contenteditable') === 'true') return;

            currentValue = cell.textContent.trim();
            cell.setAttribute('contenteditable', 'true');
            cell.focus();

            table.addEventListener('focusin', function (event) {
                const target = event.target;
                if (target.tagName === 'TD') {
                    target.style.backgroundColor = 'lightblue';
                    const rowIndex = target.parentElement.rowIndex;
                    const colIndex = target.cellIndex;

                    if (parseFloat(colIndex) > 2) {
                        const previousCellValue = parseFloat(table.rows[rowIndex].cells[colIndex - 1].textContent) || 0;
                        const previousMinusOneCellValue = parseFloat(table.rows[rowIndex].cells[colIndex - 2].textContent) || 0;

                        if (previousCellValue > previousMinusOneCellValue) {
                            const sum = previousCellValue - previousMinusOneCellValue;
                            const temp = sum + previousCellValue;
                            target.textContent = parseFloat(temp).toFixed(2);
                        }
                    }
                    else if (parseFloat(colIndex) === 1) {
                        if (parseFloat(rowIndex) > 2) {
                            const previousCellValue = parseFloat(table.rows[rowIndex - 1].cells[colIndex].textContent) || 0;
                            const previousMinusOneCellValue = parseFloat(table.rows[rowIndex - 2].cells[colIndex].textContent) || 0;

                            if (previousCellValue > previousMinusOneCellValue) {
                                const sum = previousCellValue - previousMinusOneCellValue;
                                const temp = sum + previousCellValue;
                                target.textContent = parseFloat(temp).toFixed(2);
                            }
                        }
                    }
                }
            });

            table.addEventListener('focusout', function (event) {
                const target = event.target;
                if (target.tagName === 'TD') target.style.backgroundColor = '';
            });

            cell.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    const newValue11 = cell.textContent.trim();
                    cell.setAttribute('contenteditable', 'false');
                    cell.textContent = newValue11;
                    setmainvalue(newValue11);
                    setTriggerEffect(prev => prev + 1);
                }
            });

            cell.addEventListener('focusout', function () {
                const newValue12 = cell.textContent.trim();
                cell.setAttribute('contenteditable', 'false');
                cell.textContent = parseFloat(newValue12).toFixed(2);
                setmainvalue(parseFloat(newValue12).toFixed(2));
                setTriggerEffect(prev => prev + 1);

                if (parseFloat(newValue12).toFixed(2) !== "") {
                    if (!isValidNumber(parseFloat(newValue12).toFixed(2))) {
                        setmainvalue(0);
                        cell.textContent = 0.00;
                        return;
                    }
                }
            });
        }
    };

    function isValidNumber(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }

    useEffect(() => {
        const newValue = parseFloat(mainvalue).toFixed(2);
        if (newValue !== null) {
            const updatedValues = { ...cellValues };
            updatedValues[`${rowindexmain}-${colindexmain}`] = newValue;
            setCellValues(updatedValues);

            if (colindexmain === startSNF && rowindexmain !== startFat) {
                const previousValue = cellValues[`${rowindexmain - 0.1}-${colindexmain}`] || '';
                const difference = newValue - previousValue;
                const updatedDifferences = [...fatDifferences];
                updatedDifferences[rowindexmain] = difference;
                setFatDifferences(updatedDifferences);
            }

            if (rowindexmain === startFat && colindexmain !== startSNF) {
                const previousValue = cellValues[`${rowindexmain}-${colindexmain - 0.1}`] || '';
                const difference = newValue - previousValue;
                const updatedDifferences = [...snfDifferences];
                updatedDifferences[colindexmain] = difference;
                setSNFDifferences(updatedDifferences);
            }
        }
    }, [mainvalue, triggerEffect])

    const saveratetable = () => {
        if (startFat > 0 && endFat > 0 && startSNF > 0 && endSNF > 0) {
            const table = document.getElementById('myTable');
            let query = 'INSERT INTO kratesangh (vibhag,type,rate, fat, snf,mainuser) VALUES ';

            for (let i = 1; i < table.rows.length; i++) {
                const row = table.rows[i];
                for (let j = 1; j < row.cells.length; j++) {
                    const cell = row.cells[j];
                    const value = cell.textContent;
                    const currentFat = row.cells[0].textContent;
                    const currentSNF = table.rows[0].cells[j].textContent;

                    if (value === null || value === "") {
                        notifyerror(t("ratetablesangh.toast.rate_missing", { fat: currentFat, snf: currentSNF }));
                        return;
                    }

                    query += `(${"'" + input.vibhag + "'"},${"'" + input.type + "'"},${value}, ${currentFat}, ${currentSNF}, ${"'" + localStorage.getItem("contact") + "'"})`;

                    if (i === table.rows.length - 1 && j === row.cells.length - 1) query += ';';
                    else query += ', ';
                }
            }

            var mainuser2 = jsEncode.encode("mamapr", 125);
            let rawData = {
                query: query,
                mainuser: localStorage.getItem("contact"),
                mainuser2: mainuser2,
                type: input.type,
                vibhag: input.vibhag
            }
            rawData = JSON.stringify(rawData)

            let formData = new FormData()
            formData.append('data', rawData)

            axios.post('https://excellentdairy.com/dairy/php/cust/savekratesangh.php', formData, {
                'Content-Type': 'multipart/form-data',
            }).then(function sample(response) {
                if (response.data.trim() === "Successfully saved.") { // ✅ keep excellentdairy response
                    notify(t("ratetablesangh.toast.created"));
                    getratetable();
                }
            }).catch(err => {
                console.log(err);
            });
        }
        else {
            notifyerror(t("ratetablesangh.toast.fill_fat_snf"));
        }
    }

    const updatenextrate = () => {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        let rawData = {
            vibh1: input.vibh1, vibh2: input.vibh2, vibh3: input.vibh3, vibh4: input.vibh4,
            vibh5: input.vibh5, vibh6: input.vibh6, vibh7: input.vibh7, vibh8: input.vibh8,
            vibh1gay: input.vibh1gay, vibh2gay: input.vibh2gay, vibh3gay: input.vibh3gay, vibh4gay: input.vibh4gay,
            vibh5gay: input.vibh5gay, vibh6gay: input.vibh6gay, vibh7gay: input.vibh7gay, vibh8gay: input.vibh8gay,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
        }
        rawData = JSON.stringify(rawData)

        let formData = new FormData();
        formData.append('data', rawData)

        axios.post('https://excellentdairy.com/dairy/php/cust/updatenextrate.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (response.data.trim() === "Updated.") { // ✅ keep excellentdairy response
                notify(t("ratetablesangh.toast.next_rates_ready"));
                handlenextrateclose();
            }
        }).catch(err => console.log(err));
    }

    async function getratibrate() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getratibrate.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data && response.data.length > 0) {
                response.data.map((user, index) =>
                    setRatibrate({ mhrate: user.mhrate, gayrate: user.gayrate }),
                    setNeweditratib("edit"),
                )
            }
            getkendralist();
        }).catch(err => console.log(err));
    }

    async function getoldnextrates() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getoldnextrates.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data && response.data.length > 0) {
                response.data.map((user, index) =>
                    setInput(prevInput => ({
                        ...prevInput,
                        vibh1: user.vibh1, vibh2: user.vibh2, vibh3: user.vibh3, vibh4: user.vibh4,
                        vibh5: user.vibh5, vibh6: user.vibh6, vibh7: user.vibh7, vibh8: user.vibh8,
                        vibh1gay: user.vibh1gay, vibh2gay: user.vibh2gay, vibh3gay: user.vibh3gay, vibh4gay: user.vibh4gay,
                        vibh5gay: user.vibh5gay, vibh6gay: user.vibh6gay, vibh7gay: user.vibh7gay, vibh8gay: user.vibh8gay
                    }))
                )
            }
        }).catch(err => console.log(err));
    }

    const handleGenerateClick = () => {
        const updatedValues = { ...cellValues };

        for (let fat = startFat + 0.1; fat <= endFat; fat += 0.1) {
            for (let snf = startSNF + 0.1; snf <= endSNF; snf += 0.1) {
                const cellKey = `${fat.toFixed(1)}-${snf.toFixed(1)}`;
                const prevvalue = parseFloat(updatedValues[`${(fat - 0.1).toFixed(1)}-${(snf - 0.1).toFixed(1)}`]) || 0;
                const prevvalue1 = parseFloat(updatedValues[`${fat.toFixed(1)}-${(snf - 0.1).toFixed(1)}`]) || 0;
                const prevvalueabove = parseFloat(updatedValues[`${(fat - 0.1).toFixed(1)}-${snf.toFixed(1)}`]) || 0;

                const diffrance = prevvalue1 - prevvalue;
                const diff2 = prevvalueabove + diffrance;
                updatedValues[cellKey] = parseFloat(diff2).toFixed(2);
            }
        }
        setCellValues(updatedValues);
    };

    const handleStartFatChange = (event) => setStartFat(parseFloat(event.target.value));
    const handleEndFatChange = (event) => setEndFat(parseFloat(event.target.value));
    const handleStartSNFChange = (event) => setStartSNF(parseFloat(event.target.value));
    const handleEndSNFChange = (event) => setEndSNF(parseFloat(event.target.value));

    const createTable = () => {
        const rows = [];
        const cols = [];

        for (let snf = startSNF; snf <= endSNF; snf += 0.1) {
            cols.push(<th key={snf.toFixed(1)}>{snf.toFixed(1)}</th>);
        }

        for (let fat = startFat; fat <= endFat; fat += 0.1) {
            const roundedFat = fat.toFixed(1);
            const cells = [];

            for (let snf = startSNF; snf <= endSNF; snf += 0.1) {
                const roundedSNF = snf.toFixed(1);
                const cellKey = `${roundedFat}-${roundedSNF}`;
                const cellValue = cellValues[cellKey] || '';
                cells.push(
                    <td key={cellKey} onClick={() => handleCellClick(roundedFat, roundedSNF, cellValue)}>
                        {cellValue}
                    </td>
                );
            }

            rows.push(
                <tr key={roundedFat}>
                    <th>{roundedFat}</th>
                    {cells}
                </tr>
            );
        }

        return (
            <div className="table-container">
                <table id='myTable' className="table table-bordered">
                    <thead>
                        <tr>
                            <th className='thsmallrate'>{t("ratetablesangh.table.fat_snf")}</th>
                            {cols}
                        </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            </div>
        );
    };

    function handleEnterKey(event, currentIndex) {
        if (event.keyCode === 8) {
            if (event.target.name === "time") setInput(prev => ({ ...prev, time: '' }));
            else if (event.target.name === "type") setInput(prev => ({ ...prev, type: '' }));
        }

        if (event.key === 'Backspace' && (
            (event.target.tagName === 'INPUT' && event.target.value === '') ||
            (event.target.tagName === 'SELECT' && (
                (event.target.name === 'type' && event.target.value === 'प्रकार निवडा') ||
                (event.target.name === 'time' && event.target.value === 'वेळ निवडा')
            ))
        )) {
            event.preventDefault();
            let prevIndex = currentIndex - 1;
            while (prevIndex >= 0) {
                const prevElement = inputRefs.current[prevIndex];
                if (prevElement) {
                    if ((prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') && prevElement !== event.target) {
                        prevElement.focus();
                        break;
                    } else prevIndex--;
                } else prevIndex--;
            }
        }

        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = currentIndex + 1;
            if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
        }
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                var a = str.charCodeAt(i);
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    return (
        <>
            {/* Next rate modal trigger */}
            <button type="button" className="btn btn-primary" data-bs-toggle="modal" hidden="{true}" ref={refnextrate} data-bs-target="#nextratediff"></button>

            {/* Next rate modal */}
            <div className="modal fade" id="nextratediff" tabIndex="-1" role="dialog" aria-hidden="true" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refnextrateclose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <h4 className="modal-title">{t("ratetablesangh.modal.diff_title")}</h4>

                            <div className="raterow">
                                <div className="rowcolumn">
                                    <span className='labelratered'>{t("ratetablesangh.common.buffalo")}</span>
                                    <div className="mb-2 mx-2">
                                        <span className='labelrate'>{t("ratetablesangh.modal.ratechart_dept_1")}</span>
                                        <input
                                            className="form-control vibh"
                                            id="vibh1"
                                            name="vibh1"
                                            onKeyDown={e => handleEnterKey(e, 22)} ref={ref => (inputRefs.current[22] = ref)}
                                            type="number"
                                            disabled
                                            onChange={handleChange}
                                            value={input.vibh1}
                                            autoComplete='off'
                                        />
                                    </div>
                                </div>

                                <div className="rowcolumn">
                                    <span className='labelratered'>{t("ratetablesangh.common.cow")}</span>
                                    <div className="mb-2 mx-2">
                                        <span className='labelrate'>{t("ratetablesangh.modal.ratechart_dept_1")}</span>
                                        <input
                                            className="form-control vibh"
                                            id="vibh1gay"
                                            disabled
                                            name="vibh1gay"
                                            onKeyDown={e => handleEnterKey(e, 26)} ref={ref => (inputRefs.current[26] = ref)}
                                            type="number"
                                            onChange={handleChange}
                                            value={input.vibh1gay}
                                            autoComplete='off'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handlenextrateclose}>
                                {t("common.close")}
                            </button>
                            <button type="button" className="btn btn-danger" onClick={updatenextrate}>
                                {t("common.set")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Show old modal trigger */}
            <button type="button" className="btn btn-primary" data-bs-toggle="modal" hidden="{true}" ref={refshowold} data-bs-target="#exampleModalshowold"></button>

            {/* Show old modal */}
            <div className="modal fade" id="exampleModalshowold" tabIndex="-1" role="dialog" aria-hidden="true" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refoldclose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <h4 className="modal-title">{t("ratetablesangh.modal.show_old")}</h4>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleoldclose}>
                                {t("common.no")}
                            </button>
                            <button type="button" className="btn btn-danger" onClick={getratetable}>
                                {t("common.yes")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Copy modal trigger */}
            <button type="button" className="btn btn-primary" data-bs-toggle="modal" hidden="{true}" ref={refcopy} data-bs-target="#copyratetable"></button>

            {/* Copy modal */}
            <div className="modal fade" id="copyratetable" tabIndex="-1" role="dialog" aria-hidden="true" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refcopyclose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <h6 className="modal-title">
                                {t("ratetablesangh.modal.copy_title", { type: input.type })}
                            </h6>

                            <div className='line2' />

                            <div className="rowcenter">
                                <div className="mb-2 mx-2 ratet">
                                    <span className='subheadsank'>{t("ratetablesangh.modal.select_own_center")}</span>
                                    <select value={input.centerto} name='centerto' id='centerto' onChange={handleChange} className="form-control aa" >
                                        {DataSource.map((user, index) =>
                                            <option key={index} value={user.mobno}>{user.city + " (" + user.mobno + ")"}</option>
                                        )}
                                    </select>

                                    <div className="rightdivv">
                                        {waitself
                                            ? <button type="button" className="btn btn-danger">{t("common.loading")}</button>
                                            : <button id='copysame' type="button" className="btn btn-success" onClick={copyratetableself}>
                                                {t("common.copy")}
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="rowcenter">
                                <div className="mb-2 mx-2 ratet">
                                    <span className='subheadsank'>{t("ratetablesangh.modal.select_other_center")}</span>
                                    <input type="number" placeholder={t("ratetablesangh.labels.password")} className="form-control inputfontkhlarge" autoComplete='off' id="pass" name="pass" value={input.pass} onChange={handleChange} />
                                    <input type="number" maxLength={10} className="form-control inputfontkhlarge" autoComplete='off' id="iname" name="iname" value={input.iname} onChange={handleChange} />
                                    <input value={input.centertoitr} name='centertoitr' id='centertoitr' onChange={handleChange} className="form-control aa" />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handlecopyclose}>
                                {t("common.close")}
                            </button>
                            {wait
                                ? <button type="button" className="btn btn-danger">{t("common.loading")}</button>
                                : <button type="button" className="btn btn-success" onClick={copyratetabledairy}>
                                    {t("common.copy")}
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/* Main */}
            <div className="ratemain">
                <div className="firstrow">
                    <img onClick={props.visibility} className='back' src={back} alt="" />
                    <span>{t("ratetablesangh.title")}</span>
                </div>

                <div className='line' />

                <div className="selection">
                    <div className='vline'></div>

                    <div className="mb-2 mx-2 rate">
                        <span className='subheadsank'>{t("ratetablesangh.labels.ratechart_dept")}</span>
                        <select
                            disabled={newedit === "edit" ? 'true' : ''}
                            onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)}
                            value={input.vibhag}
                            name='vibhag'
                            id='vibhag'
                            onChange={handleChange}
                            className="form-control aa"
                        >
                            {/* ✅ keep value same for logic */}
                            <option key={0} value="विभाग निवडा">{t("ratetablesangh.labels.select_dept")}</option>
                            <option key={1} value="Ratechart-1">Ratechart-1</option>
                        </select>
                    </div>

                    <div className="mb-2 mx-2">
                        <span className='subheadsank'>{t("ratetablesangh.labels.type")}</span>
                        <select
                            disabled={input.vibhag === "विभाग निवडा" || input.vibhag === "" ? 'true' : newedit === "edit" ? 'true' : ''}
                            onKeyDown={e => handleEnterKey(e, 1)} ref={ref => (inputRefs.current[1] = ref)}
                            value={input.type}
                            name='type'
                            id='type'
                            onChange={handleChange}
                            className="form-control"
                        >
                            {/* ✅ keep value same for logic */}
                            <option key={0} value="प्रकार निवडा">{t("ratetablesangh.labels.select_type")}</option>
                            <option key={1} value="Buffalo">{t("ratetablesangh.common.buffalo")}</option>
                            <option key={2} value="Cow">{t("ratetablesangh.common.cow")}</option>
                        </select>
                    </div>

                    <div className='vline'></div>

                    <div className="mb-2 mx-2">
                        <span className='subhead'>{t("ratetablesangh.labels.fat")}</span>
                        <div className="selection">
                            <input
                                className="form-control"
                                id="startFatInput"
                                onKeyDown={e => handleEnterKey(e, 2)} ref={ref => (inputRefs.current[2] = ref)}
                                type="number"
                                disabled={input.vibhag === "विभाग निवडा" || input.vibhag === "" ? 'true' : newedit === "edit" ? 'true' : ''}
                                step="0.1"
                                value={startFat}
                                onChange={handleStartFatChange}
                                autoComplete='off'
                            />
                            <span>{t("common.to")}</span>
                            <input
                                className="form-control"
                                id="endFatInput"
                                onKeyDown={e => handleEnterKey(e, 3)} ref={ref => (inputRefs.current[3] = ref)}
                                disabled={input.vibhag === "विभाग निवडा" || input.vibhag === "" ? 'true' : newedit === "edit" ? 'true' : ''}
                                type="number"
                                step="0.1"
                                value={endFat}
                                onChange={handleEndFatChange}
                                autoComplete='off'
                            />
                        </div>
                    </div>

                    <div className='vline'></div>

                    <div className="mb-2 mx-2">
                        <span className='subhead'>{t("ratetablesangh.labels.snf")}</span>
                        <div className="selection">
                            <input
                                className="form-control"
                                onKeyDown={e => handleEnterKey(e, 4)} ref={ref => (inputRefs.current[4] = ref)}
                                id="startSNFInput"
                                type="number"
                                step="0.1"
                                disabled={input.vibhag === "विभाग निवडा" || input.vibhag === "" ? 'true' : newedit === "edit" ? 'true' : ''}
                                value={startSNF}
                                onChange={handleStartSNFChange}
                                autoComplete='off'
                            />
                            <span>{t("common.to")}</span>
                            <input
                                className="form-control"
                                id="endSNFInput"
                                onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)}
                                type="number"
                                disabled={input.vibhag === "विभाग निवडा" || input.vibhag === "" ? 'true' : newedit === "edit" ? 'true' : ''}
                                step="0.1"
                                value={endSNF}
                                onChange={handleEndSNFChange}
                                autoComplete='off'
                            />
                        </div>
                    </div>

                    <div className="bb">
                        <div className="a">asdf</div>
                        <div className="selection">
                            {(input.vibhag === "Ratechart-1" || input.vibhag === "Ratechart-9 (M)") && input.type !== "प्रकार निवडा"
                                ? <>
                                    <button disabled={newedit === "edit" ? 'true' : ''} onClick={handleGenerateClick} type='button' className="btn btn-primary mx-1">
                                        {t("ratetablesangh.buttons.autocomplete")}
                                    </button>

                                    <button onClick={saveratetable} type='button' className="btn btn-primary">
                                        {newedit === "new" ? t("common.save") : t("common.update")}
                                    </button>

                                    {newedit === "edit"
                                        ? (localStorage.getItem("contact") && localStorage.getItem("contact").includes("-"))
                                            ? ''
                                            : <button type="button" id='copy' className="btn btn-success mx-1 sanksmall" onClick={handlecopy}>
                                                {t("common.copy")}
                                            </button>
                                        : ''
                                    }
                                </>
                                : ''
                            }
                        </div>
                    </div>
                </div>

                {createTable()}
                <ToastContainer />
            </div>
        </>
    );
};

export default Ratetablesangh;
